function formatDateIT(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function ConflictsPanel({
  allConflictDocs,
  conflictDocs,
  hiddenByFilter,
  operatorOptions,
  operatorFilter,
  setOperatorFilter,
  onlyMine,
  setOnlyMine,
  onOpenDoc,
}) {
  if (allConflictDocs.length === 0) return null;
  return (
    <aside data-testid="calendar-conflicts-panel" className="card-surface p-4 space-y-3 lg:sticky lg:top-20 lg:self-start lg:max-h-[calc(100vh-8rem)] lg:overflow-auto">
      <div className="flex items-center gap-2 pb-2 border-b border-red-200">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-sm bg-red-100 text-red-700 text-xs font-bold">⚠</span>
        <div>
          <h3 className="text-sm font-semibold text-red-700 font-['Outfit']">Date sovrapposte</h3>
          <p className="text-xs text-zinc-500">
            {conflictDocs.length} {conflictDocs.length === 1 ? "documento" : "documenti"} con date sovrapposte
            {(onlyMine || operatorFilter !== "all") && hiddenByFilter > 0 ? ` (${hiddenByFilter} nascosti)` : ""}
          </p>
        </div>
      </div>
      <div className="space-y-2">
        <div className="space-y-1">
          <label className="text-[11px] font-medium text-zinc-600 uppercase tracking-wide">Filtra per operatore</label>
          <select
            data-testid="conflicts-operator-filter"
            value={operatorFilter}
            onChange={(e) => {
              setOperatorFilter(e.target.value);
              localStorage.setItem("calendar_operator_filter", e.target.value);
            }}
            disabled={onlyMine}
            className="w-full text-xs border border-zinc-200 rounded-sm px-2 py-1.5 bg-white disabled:bg-zinc-50 disabled:text-zinc-400 focus:outline-none focus:border-zinc-400"
          >
            <option value="all">Tutti gli operatori</option>
            {operatorOptions.map((o) => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>
        <label className="flex items-center gap-2 text-xs cursor-pointer select-none">
          <input
            type="checkbox"
            data-testid="conflicts-only-mine-toggle"
            checked={onlyMine}
            onChange={(e) => {
              setOnlyMine(e.target.checked);
              localStorage.setItem("calendar_only_mine", String(e.target.checked));
            }}
            className="rounded-sm"
          />
          <span className="text-zinc-700">Solo miei lavori</span>
        </label>
      </div>
      {conflictDocs.length === 0 ? (
        <p className="text-xs text-zinc-500 italic pt-2">
          {onlyMine
            ? "Nessun documento con date sovrapposte assegnato a te."
            : "Nessun documento corrisponde al filtro selezionato."}
        </p>
      ) : (
        <ul className="space-y-2">
          {conflictDocs.map((doc) => (
            <li key={doc.key}>
              <button
                type="button"
                data-testid={`conflict-item-${doc.doc_id}`}
                onClick={() => onOpenDoc(doc)}
                className="w-full text-left p-3 rounded-sm border border-red-200 bg-red-50/60 hover:bg-red-100 transition-colors group"
              >
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs font-semibold text-red-700">{doc.number}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-sm ${doc.doc_type === "inventory" ? "bg-purple-100 text-purple-700" : "bg-blue-100 text-blue-700"}`}>
                    {doc.doc_type === "inventory" ? "Inventario" : "Preventivo"}
                  </span>
                </div>
                <div className="text-sm text-zinc-800 truncate mt-1">{doc.customer_name || "—"}</div>
                <div className="text-xs text-zinc-500 mt-0.5">
                  {formatDateIT(doc.start)} → {formatDateIT(doc.end)}
                </div>
                <div className="text-[11px] text-zinc-500 mt-0.5">
                  Operatore: {doc.assigned_to_name || <span className="italic text-zinc-400">non assegnato</span>}
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
